import styled from "styled-components";

const ModalHeading = styled.h1`
  margin-bottom: 2rem;
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.text};
  font-weight: bold;
`;

export default ModalHeading;
